import Discussion from 'flarum/common/models/Discussion';
import Model from 'flarum/common/Model';
export default function extendDiscussionModel() {
  Object.assign(Discussion.prototype, {
    isClassifieds: Model.attribute('isClassifieds'),
    canMarkListingSold: Model.attribute('canMarkListingSold'),
    canBumpListing: Model.attribute('canBumpListing'),
    canEditListing: Model.attribute('canEditListing'),
    listingLabel: Model.attribute('listingLabel'),
    listingStatus: Model.attribute('listingStatus'),
    listingPrice: Model.attribute('listingPrice'),
    listingPriceMax: Model.attribute('listingPriceMax'),
    listingCurrency: Model.attribute('listingCurrency'),
    listingLocation: Model.attribute('listingLocation'),
    listingSoldAt: Model.attribute('listingSoldAt', Model.transformDate),
    listingBumpedAt: Model.attribute('listingBumpedAt', Model.transformDate),
    listingImages: Model.attribute('listingImages')
  });
}
flarum.reg.add('ramon-classifieds', 'common/extendDiscussionModel', extendDiscussionModel);